import { ElMessageBox } from 'element-plus'

// 动态 import 失败兜底:页面打开超过 7 天(旧 hash chunk 已被部署流程清理)或缓存异常时,
// 再点击未加载过的菜单/弹窗会 chunk 404,无人处理就表现为"点了没反应"。
// 命中后自动刷新拉取新版本(刷新前记录当前路由,入口启动时自动恢复);
// 刷新后仍是旧 chunk(本地/边缘缓存异常)则改为提示手动刷新,防死循环。

const CHUNK_ERROR_PATTERNS = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
  'Unable to preload CSS'
]

const RELOAD_MARK_KEY = 'chunkErrorReloadAt'
const RELOAD_INTERVAL = 5 * 60 * 1000
const RETURN_TO_KEY = 'chunkErrorReturnTo'

let getFullPath: (() => string) | null = null

// 刷新前记录当前路由，刷新后入口恢复，用户不用再手动找回刚才的页面
const saveReturnTo = () => {
  const fullPath = getFullPath?.()
  if (fullPath) sessionStorage.setItem(RETURN_TO_KEY, fullPath)
}

// 入口启动时调用：chunk 404 兜底刷新后自动回到用户刚才所在页面（取一次即清）
export const consumeChunkErrorReturnTo = (): string | null => {
  const to = sessionStorage.getItem(RETURN_TO_KEY)
  if (to) sessionStorage.removeItem(RETURN_TO_KEY)
  return to
}

const isChunkLoadError = (reason: any): boolean => {
  const msg = String(reason?.message || reason || '')
  return CHUNK_ERROR_PATTERNS.some(p => msg.includes(p))
}

const handleChunkError = () => {
  saveReturnTo()
  const last = Number(sessionStorage.getItem(RELOAD_MARK_KEY) || 0)
  if (Date.now() - last < RELOAD_INTERVAL) {
    ElMessageBox.alert('系统已发布新版本,请刷新页面后继续使用。', '提示', {
      confirmButtonText: '立即刷新',
      showClose: false
    }).then(() => {
      sessionStorage.removeItem(RELOAD_MARK_KEY)
      window.location.reload()
    }).catch(() => {})
    return
  }
  sessionStorage.setItem(RELOAD_MARK_KEY, String(Date.now()))
  window.location.reload()
}

let installed = false
export const installChunkErrorGuard = (getCurrentFullPath?: () => string) => {
  if (installed) return
  installed = true
  getFullPath = getCurrentFullPath || null
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    handleChunkError()
  })
  window.addEventListener('unhandledrejection', (event) => {
    if (!isChunkLoadError(event.reason)) return
    event.preventDefault()
    handleChunkError()
  })
}
